
<script>
import vue2Dropzone from 'vue2-dropzone'
import config from "../../config";
import VueGoogleAutocomplete from 'vue-google-autocomplete';
import { driverService, userService } from '../../services';
import { get_user, error_message, success_message} from '../../Helper/helper';
import DropzonePopup from '../../components/widgets/dropzone-popup';
import {required,email,numeric} from "vuelidate/lib/validators";
import { routes } from '../../config/api_routes';

export default {
  components: { vueDropzone: vue2Dropzone,VueGoogleAutocomplete, DropzonePopup },
  data() {
    return {
      config:config,
      tmpProfileImage: '',
      value: null,
      value1: null,
      zones:[],
      isDisabled:false,
      country_code : "+49",
      typeform: 
      {
        firstname: "",
        lastname: "",
        email: "",
        contactno: "",
        alternate_contactno: "",
        frenchise_id: "",
        address: "",
        firstname_other_lang: "",
        lastname_other_lang: "",
        profileimage: "",
        city: "",
        state: "",
        customer_type:2,
        zip_code: "",
        country: "",
        latitude:"",
        longitude: "",
        username: "",
        password:"",
        is_block: "0"
      },
      typesubmit: false
    };
  },
  validations: {
    typeform: {
      firstname: {
        required
      },
      firstname_other_lang: {
        required
      },
      lastname: {
        required
      },
      lastname_other_lang: {
        required
      },
      email: {
        required,
        email
      },
      contactno: {
        required,
        numeric
      },
      address: {
        required
      },
      password: {
        required
      },
      username: {
        required
      },
      alternate_contactno: {
        required,
        numeric
      },
      customer_type: { 
        required 
      },
    }
  },
  mounted(){
    this.getFrenchise();
    this.$refs.address.focus();
    this.vendor_id = get_user().vendor_id || 40818;
  },
  methods: {
    userCheckEmail(e) {
      userService.userCheckEmail({
        email:this.typeform.email,
        table:'User',
        column:'driverid',
        vendor_id:this.vendor_id,
        user_role:'3',
        table_name:'Driver'
      })
      .then(response => {
        if (response.data.code === 101) {
          error_message(response.data.message);
        }
      });
    },
    
    getAddressData: function (addressData, placeResultData, id) {
      this.address = addressData;
      //console.log(addressData);
      
      this.typeform.address = placeResultData.formatted_address;
      this.typeform.city = addressData.locality;
      this.typeform.state = addressData.administrative_area_level_1;
      this.typeform.country = addressData.country;
      this.typeform.latitude = addressData.latitude;
      this.typeform.longitude = addressData.longitude;
      this.typeform.zip_code = addressData.postal_code;
    },
    getFrenchise(){
      driverService.getFrenchise()
      .then(response => {
          this.zones =  response.data.result;
      });
    },
    typeForm(e) {
      this.$v.$touch();
      if (this.$v.typeform.$invalid) {
        setTimeout(()=>{
            $('html, body').animate({
                scrollTop: $(".is-invalid:first").offset().top-$('#page-topbar').height()-50
            }, 500, function() {
                $(".is-invalid:first").focus();
            });
        },500);
        return;
      }
      else{       
        this.isDisabled = true;
        driverService.addDriver(this.typeform)
        .then(response => {
          if (response.data.code === 200) {
            success_message(response.data.message);
            this.$router.push({ name: "driver-list" });
          } else {
            this.isDisabled = false;
            error_message(response.data.message);
          }
        });
      }
    },
  }
}
</script>

<template>
  <div>
    <div class="row">
     <div class="col-12">
       <form action="#" @submit.prevent="typeForm">

      <!-- Driver Info Start -->
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">{{ trans.get('__JSON__.Personal Information') }}</h4>
            <p class="card-title-desc"></p>
            <div class="row">
              <div class="col-sm-6">
                <div class="form-group" v-if="$auth.setting">
                  <label class="required">{{ trans.trans('__JSON__.First Name Primary Language',{lang: $auth.langauges[0].name}) }}</label>
                  <input id="firstname" v-model="$v.typeform.firstname.$model" type="text" class="form-control" :placeholder="trans.trans('__JSON__.First Name Primary Language',{lang: $auth.langauges[0].name})" name="firstname" :class="{ 'is-invalid':$v.typeform.firstname.$error }" tabindex="1"/>
                    <div v-if="$v.typeform.firstname.$error" class="invalid-feedback">
                      <span v-if="!$v.typeform.firstname.required">{{ trans.get('__JSON__.Please enter first name') }}</span>
                    </div>
                </div>
              </div>

              <div class="col-sm-6">
                <div class="form-group">
                  <label class="required">{{ trans.trans('__JSON__.Last Name Primary Language',{lang: $auth.langauges[0].name}) }}</label>
                  <input id="lastname" v-model="$v.typeform.lastname.$model" type="text" class="form-control" :placeholder="trans.trans('__JSON__.Last Name Primary Language',{lang: $auth.langauges[0].name})" name="lastname" :class="{ 'is-invalid':$v.typeform.lastname.$error }" tabindex="2" />
                    <div v-if="$v.typeform.lastname.$error" class="invalid-feedback">
                      <span v-if="!$v.typeform.lastname.required">{{ trans.get('__JSON__.Please enter last name') }}</span>
                    </div>
                </div>
              </div>

              <div class="col-sm-6" v-if="$auth.langauges[1].name != 'No Secondary Language'">
                <div class="form-group">
                  <label class="required">{{ trans.trans('__JSON__.First Name Secondary Language',{lang: $auth.langauges[1].name}) }}</label>
                  <input id="firstname_other_lang" name="firstname_other_lang" v-model="$v.typeform.firstname_other_lang.$model" type="text" :placeholder="trans.trans('__JSON__.First Name Secondary Language',{lang: $auth.langauges[1].name})" class="form-control" :class="{ 'is-invalid':$v.typeform.firstname_other_lang.$error }" tabindex="3"/>
                  <div v-if="$v.typeform.firstname_other_lang.$error" class="invalid-feedback">
                      <span v-if="!$v.typeform.firstname_other_lang.required">{{ trans.get('__JSON__.Please enter first name') }}</span>
                    </div>
                </div>
              </div>

              <div class="col-sm-6" vv-if="$auth.langauges[1].name != 'No Secondary Language'">
                <div class="form-group">
                  <label class="required">{{ trans.trans('__JSON__.Last Name Secondary Language',{lang: $auth.langauges[1].name}) }}</label>
                  <input id="lastname_other_lang" name="lastname_other_lang" v-model="typeform.lastname_other_lang" type="text" :placeholder="trans.trans('__JSON__.Last Name Secondary Language',{lang: $auth.langauges[1].name})" class="form-control" :class="{ 'is-invalid':$v.typeform.lastname_other_lang.$error }" tabindex="4"/>
                  <div v-if="$v.typeform.lastname_other_lang.$error" class="invalid-feedback">
                      <span v-if="!$v.typeform.lastname_other_lang.required">{{ trans.get('__JSON__.Please enter last name') }}</span>
                    </div>
                </div>
              </div>

              <div class="col-sm-6">
                <div class="form-group">
                  <label class="required">{{ trans.get('__JSON__.E-Mail') }}</label>
                      <input id="email" v-model="$v.typeform.email.$model" type="email" name="email" class="form-control" @blur="userCheckEmail" :class="{ 'is-invalid':$v.typeform.email.$error }" :placeholder="trans.get('__JSON__.Enter Email')" tabindex="5"/>
                      <div v-if="$v.typeform.email.$error" class="invalid-feedback">
                          <span v-if="!$v.typeform.email.required">{{ trans.get('__JSON__.Please enter email') }}</span>
                          <span v-if="!$v.typeform.email.email">{{ trans.get('__JSON__.This value should be a valid email') }}</span>
                      </div>
                  </div>
              </div>

              <div class="col-sm-6">
                <label class="required">{{ trans.get('__JSON__.Primary Contact Number') }}</label>
                <div class="no-grid">
                  <div class="input-group-prepend">
                    <span class="input-group-text">{{ country_code }}</span>
                  </div>
                  <input  type="tel" maxlength="15" minlength="11" id="contactno" v-model="$v.typeform.contactno.$model"  name="contactno" class="form-control" :class="{ 'is-invalid':$v.typeform.contactno.$error }" :placeholder="trans.get('__JSON__.Primary contact number')" tabindex="7"/>
                  <div v-if="$v.typeform.contactno.$error" class="invalid-feedback" style="grid-column: span 2;">
                      <span v-if="!$v.typeform.contactno.required">{{ trans.get('__JSON__.Please enter contact number') }}</span>
                      <span v-if="!$v.typeform.contactno.numeric">{{ trans.get('__JSON__.This value should be a valid number') }}</span>
                  </div>
                </div>
              </div>

              <div class="col-sm-6">
                <label class="required">{{ trans.get('__JSON__.Personal contact number') }}</label>
                <div class="no-grid">
                  <div class="input-group-prepend">
                    <span class="input-group-text">{{ country_code }}</span>
                  </div>
                  <input id="alternate_contactno" maxlength="15" minlength="11" v-model="typeform.alternate_contactno" type="tel" name="alternate_contactno" class="form-control" :placeholder="trans.get('__JSON__.Personal contact number')"  :class="{ 'is-invalid':$v.typeform.alternate_contactno.$error }" tabindex="7"/>
                  <div v-if="$v.typeform.alternate_contactno.$error" class="invalid-feedback" style="grid-column: span 2;">
                      <span v-if="!$v.typeform.alternate_contactno.required">{{ trans.get('__JSON__.Please enter personal number') }}</span>
                      <span v-if="!$v.typeform.alternate_contactno.numeric">{{ trans.get('__JSON__.This value should be a valid number') }}</span>
                  </div>
                </div>
              </div>

              <div class="col-sm-6">
                <div class="form-group">
                    <label class="control-label required">{{ trans.get('__JSON__.Full address') }}</label>
                      <vue-google-autocomplete
                          ref="address"
                          id="addres"
                          name="address"
                          type="text"
                          tabindex="8"
                          class="form-control"
                          placeholder="Please type your address"
                          v-on:placechanged="getAddressData"
                          :class="{'is-invalid':$v.typeform.address.$error}"
                      >
                      </vue-google-autocomplete>
                      <div v-if="$v.typeform.address.$error" class="invalid-feedback">
                        <span v-if="!$v.typeform.address.required">{{ trans.get('__JSON__.Please enter address') }}</span>
                      </div>
                </div>
              </div>

              <div class="col-sm-6">
                <div class="form-group">
                  <label class="required">{{ trans.get('__JSON__.User Name') }}</label>
                    <input id="username" v-model="$v.typeform.username.$model" type="text" name="username" class="form-control" :class="{ 'is-invalid':$v.typeform.username.$error }" :placeholder="trans.get('__JSON__.UserName')" tabindex="9"/>
                    <div v-if="$v.typeform.username.$error" class="invalid-feedback">
                      <span v-if="!$v.typeform.username.required">{{ trans.get('__JSON__.Please enter username') }}</span>
                    </div>
                </div>
              </div>

              <div class="col-sm-6">
                <div class="form-group">
                  <label class="required">{{ trans.get('__JSON__.Password') }}</label>
                    <input id="password" v-model="$v.typeform.password.$model" type="password" name="password" class="form-control" :class="{ 'is-invalid':$v.typeform.password.$error }" :placeholder="trans.get('__JSON__.Password')" tabindex="10"/>
                    <div v-if="$v.typeform.password.$error" class="invalid-feedback">
                      <span v-if="!$v.typeform.password.required">{{ trans.get('__JSON__.Please enter password') }}</span>
                    </div>
                </div>
              </div>

              <div class="col-md-6 vendor-status">
                <b-form-group
                    id="input-group-2"
                    :label="trans.get('__JSON__.Status')"
                    label-for="Status"
                >
                    <div class="row">
                      <div class="col-sm-6">
                        <div class="swtich-data">
                          <label class="switch">
                              <input
                              type="checkbox"
                              id="togBtn"
                              class="switch-on"
                              name="is_block"
                              v-model="typeform.is_block"
                              true-value="0"
                              false-value="1"
                              tabindex="11"
                              />
                              <div class="slider round">
                                <span class="on">{{ trans.get('__JSON__.Active') }}</span>
                                <span class="off">{{ trans.get('__JSON__.Inactive') }}</span>
                              </div>
                          </label>
                        </div>
                      </div>
                    </div>
                </b-form-group>
              </div>

              <div class="col-sm-6">
                <div class="form-group">
                  <label class="control-label">{{ trans.get('__JSON__.Profile Image') }}</label>
                    <dropzone-popup v-model="typeform.profileimage" id="profile_image" name="profile_image" acceptedFiles=".jpeg,.jpg,.png" />
                </div>
              </div>

              <div class="col-md-6 vendor-status">
                <b-form-group
                    id="input-group-2"
                    :label="trans.get('__JSON__.Customer Type')"
                    label-for="Customer Type"
                >      
                  <select
                    v-model="typeform.customer_type"
                    class="form-control"
                    :class="{ 'is-invalid': $v.typeform.customer_type.$error }"
                    id="customer_type"
                  >
                    <!-- <option value="0">Both</option> -->
                    <option value="1">Business</option>
                    <option value="2">Private</option>
                  </select>
                  <div v-if="$v.typeform.customer_type.$error" class="invalid-feedback">
                    <span v-if="!$v.typeform.customer_type.required">{{ trans.get('__JSON__.Please select Customer Type') }}</span>
                  </div>
                </b-form-group>
              </div>

            </div>
            <div class="row">
              <div class="col-sm-6">
                <button type="submit" class="btn btn-primary mr-1 mt-3" :disabled="isDisabled">{{ trans.trans('__JSON__.Add Driver',{ driver: $auth.setting.driver_name }) }}</button>
                <!-- <b-button @click="$router.go(-1)" type="button" variant="secondary" class="mt-3">{{ trans.get('__JSON__.Cancel') }}</b-button> -->
                <router-link
                  :to="{name:'driver-list'}"
                >
                  <b-button 
                    type="button" 
                    variant="secondary" 
                    class="mt-3">
                    {{ trans.get('__JSON__.Cancel') }}
                  </b-button>
                </router-link>
              </div>
            </div>
          </div>
        </div>
        
        <!-- Driver Info End -->
        </form>
      </div>
      
    </div>
    <!-- end row -->
  </div>
</template>
<style scoped>
.no-grid{
    display: grid;
    grid-template-columns: 50px 1fr;
}
</style>
